exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.best_buys_tabs[data-v-27098cbd] {\n padding: 12px;\n}\n", ""]);

// exports
